export default function MicroCredits() {
  const cards = [
    {
      title: 'Earn',
      description: 'Earn MicroCredits™ by completing MicroSkills, badges and challenges.',
      icon: 'ri-flashlight-line',
      gradient: 'from-[#304FFE] to-[#5B9FED]',
    },
    {
      title: 'Progress',
      description: 'MicroCredits™ reflect your learning effort and unlock new pathways.',
      icon: 'ri-arrow-up-line',
      gradient: 'from-[#7C4DFF] to-[#B794F6]',
    },
    {
      title: 'Redeem',
      description: 'Use MicroCredits™ for scholarships, AI boosts and exclusive rewards.',
      icon: 'ri-gift-line',
      gradient: 'from-[#FF6B9D] to-[#FFA726]',
    },
  ];

  return (
    <section className="py-28 px-6 lg:px-12 relative overflow-hidden">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/[0.08] via-transparent to-[#7C4DFF]/[0.08]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      </div>

      {/* Floating decorative elements */}
      <div className="absolute top-1/4 right-[10%] w-64 h-64 bg-gradient-to-br from-[#304FFE]/20 to-[#7C4DFF]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-[15%] w-48 h-48 bg-gradient-to-br from-[#7C4DFF]/15 to-[#304FFE]/15 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F36] mb-6">
            MicroCredits™ — The currency of progress
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Earn MicroCredits™ every time you complete MicroSkills, unlock badges or achieve MicroCredentials.
            Redeem them for scholarships, fast-track access, AI Tutor boosts and exclusive opportunities.
            The more you learn, the more your future opens.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {cards.map((card, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 border border-gray-100 shadow-lg relative overflow-hidden"
            >
              {/* Subtle background gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${card.gradient} opacity-[0.03] group-hover:opacity-[0.06] transition-opacity`}></div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className={`w-20 h-20 bg-gradient-to-br ${card.gradient} rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 group-hover:rotate-3 transition-all shadow-xl`}>
                  <i className={`${card.icon} text-4xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1A1F36] mb-4 text-center">{card.title}</h3>
                <p className="text-base text-gray-600 leading-relaxed text-center">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="px-8 py-4 bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white font-medium rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
            Learn how MicroCredits™ work →
          </button>
        </div>
      </div>
    </section>
  );
}
